import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { OrganizationService, SiteMembershipService } from '@se-po/shared-data-access-services'
import { merge, Observable, of } from 'rxjs'
import { catchError, first, map, switchMap } from 'rxjs/operators'

export const OPEN_REGISTRATION_FEATURE_TOGGLE_KEY = 'open_registration'

export function hasOpenRegistrationEnabled(
  organizationService: OrganizationService,
  siteMembershipService: SiteMembershipService
): Observable<boolean> {
  return siteMembershipService.mine().pipe(
    map((siteMemberships) => [
      ...new Set(siteMemberships.map((siteMembership) => siteMembership.organization_id)),
    ]),
    switchMap((organizationIds) => {
      if (!organizationIds.length) return of(false)

      return merge(...organizationIds.map((organizationId) =>
        organizationService.hasFeatureToggleEnabled(
          organizationId.toString(),
          OPEN_REGISTRATION_FEATURE_TOGGLE_KEY
        ).pipe(
          catchError(() => of(false))
        )
      )).pipe(
        first((result) => result === true, false),
      )
    }),
    catchError(() => of(false))
  )
}

export const openRegistrationRouteGuard: CanActivateFn = () => {
  const organizationService = inject(OrganizationService)
  const siteMembershipService = inject(SiteMembershipService)
  const router = inject(Router)

  return hasOpenRegistrationEnabled(organizationService, siteMembershipService).pipe(
    map((enabled) => enabled || router.createUrlTree(['user', 'registrations']))
  )
}
